// MARK: Types
import Style from "types/globals/styleguide/style";
// MARK: Function
const getStyles = (styles: Array<Style>, slug: string) => {
  // MARK: Variables
  const defaultStyle: Style = {
    title: "default",
    slug: "default",
    font: "din-2014",
    fontSize: 10,
    fontWeight: 100,
    lineHeight: 1.6,
  };
  // MARK: Algorithm
  const style = styles.filter((style) => style.slug === slug)[0];
  return style === undefined || style === null ? defaultStyle : style;
};

export default getStyles;
